import React, { useState, useEffect, useContext } from "react";
// import { GoujianForm, UserProfileForm } from "./components/forms/Forms";
import { Router, Link, Redirect } from "@reach/router";
import { NavBar } from "./components/navigationbar";
import { SnackbarProvider, withSnackbar } from "notistack";
import SERVER_ADDRESS from "./config";
import store from "./reduxstore";
import {
  Introduction,
  InfoRouter,
  LearnPageRouter,
  PanoPage,
  Virtual,
  GradePage,
} from "./components/pages";

import { hasRole, authWrapper, LoginModalPage } from "./auth";
import Footer from "./Footer";
// import { useTestState } from "./ilabx-grade-return";

//对接北京大学Vlab平台，根据访问所带token进行身份判断
const VLAB_MEMBERINFO_ADDRESS = "http://162.105.209.225/member/memberinfo";

//北大账号信息map到项目所需身份信息
function mapVlabAccount(vlabAccount) {
  const username = vlabAccount.data.dataField.username;
  const email = vlabAccount.data.dataField.email;
  const account = {
    id: `vlab_account_${username}`,
    username: username,
    email: email || "unset",
    groups: ["teacher"],
    nickname: username,
    role: "学生",
    card_number: "",
  };

  return account;
}

function useReduxAccount() {
  useEffect(() => {
    //对接北京大学Vlab平台，根据访问所带token进行身份判断
    let params = new URL(window.location.href).searchParams;
    let vlabToken;
    const tokenParam = params.get("token");

    if (tokenParam) {
      vlabToken = tokenParam;
    } else {
      vlabToken = window.localStorage.getItem("vlabToken");
    }

    async function wrapper() {
      let vlabAccount;
      if (vlabToken) {
        //身份token存在
        vlabAccount = await fetch(`${VLAB_MEMBERINFO_ADDRESS}`, {
          headers: {
            "APP-Auth-Token": vlabToken,
          },
        })
          .then((res) => res.json())
          .catch((err) => {
            // console.log(err);
            return null;
          });
      }

      //token争取 可以获取真实用户的情况下，存储在localStorage里
      if (vlabAccount) {
        const vlabAccountData = mapVlabAccount(vlabAccount);
        store.dispatch({
          type: "UPDATEAccount",
          account: { ...vlabAccountData, vlabToken }, //信息里加入vlabToken字段
        });
        window.localStorage.setItem("vlabToken", vlabToken);
      } else {
        const currentAcount = await fetch(`${SERVER_ADDRESS}/api/users/me/`, {
          mode: "cors",
          credentials: "include",
        }).then((res) => res.json());

        store.dispatch({ type: "UPDATEAccount", account: currentAcount });
      }
    }
    wrapper();
  }, []);
  return null;
}

//获取文献选项
function useReduxWenxianOptions() {
  const fetchUrl = `${SERVER_ADDRESS}/api/wenxians.json/`;

  useEffect(() => {
    async function wrapper() {
      const wenxianRaw = await fetch(fetchUrl, {
        mode: "cors",
        credentials: "include",
      }).then((res) => {
        return res.json();
      });
      let wenxian = wenxianRaw.map(({ id, name }) => {
        return { name, id };
      });
      store.dispatch({ type: "UPDATEWenxianOptions", wenxianOptions: wenxian });
    }
    wrapper();
  }, []);
  return null;
}

//获取构件分类信息
function useReduxGoujianCategoryOptions() {
  useEffect(() => {
    async function wrapper() {
      const category = await fetch(`${SERVER_ADDRESS}/api/goujians/category/`, {
        mode: "cors",
        credentials: "include",
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => data.category);
      store.dispatch({
        type: "UPDATECategoryOptions",
        categoryOptions: category,
      });
    }
    wrapper();
  }, []);
  return null;
}

function useReduxInit() {
  useReduxAccount();
  useReduxWenxianOptions();
  useReduxGoujianCategoryOptions();
}

function App(props) {
  useReduxInit();

  return (
    <>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Router primary={false}>
          <NavBar path="/index" nav="index" />
          <NavBar path="/learn/*" nav="learn" />
          <NavBar path="/info/*" nav="info" />
          <NavBar path="/realitylearn" nav="realitylearn" />
          <NavBar path="/virtuallearn" nav="virtuallearn" />
          <NavBar path="/grade/" nav="index" />

          <Redirect from="*" to="/index" noThrow />
        </Router>

        <Router>
          <Introduction path="/index" />
          <LearnPageRouter path="/learn/*" />
          {hasRole(["学生", "教师"]) && <InfoRouter path="/info/*" />}

          {hasRole(["学生", "教师"]) && <PanoPage path="/realitylearn/*" />}
          {hasRole(["学生", "教师"]) && <GradePage path="/grade/" />}

          {hasRole(["学生", "教师"]) && (
            <Virtual
              path="/virtuallearn/*"
              virtualUrl="http://cdn.yungujian.com/qgsExp/index.html"
            />
          )}
          {hasRole(["访客"]) && <LoginModalPage path="*" default />}
        </Router>
      </SnackbarProvider>
      <Footer />
    </>
  );
}

export default App;
